import { Component, OnInit } from "@angular/core";
// import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import { UserMgmtService } from "../user.service";


@Component({
  selector: 'app-view-user',
  templateUrl: './view-user.component.html',
  styleUrls: ['./view-user.component.scss']
})
export class ViewUserComponent implements OnInit {
  userDetails;
  query: string;
  statusFormSubmitted: boolean = false;
  statusForm: FormGroup;
  statusList: Array<object> = [
    { id: "active", name: "Active" },
    { id: "blocked", name: "Blocked" },
    { id: "suspended", name: "Suspend" }

  ];

  // END - Update user variable
  // filters
  searchStartDate: string;
  searchEndDate: string;
  searchUserStatus: string = "all";
  searchBy: string = "all";
  searchText: string;
// filters end

  userList = [];
  weeeklyRewardList:[];
  permanentRewardList:[];
  details:any;
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  pageLimit: number = 10;
  userSearchType: number = 0;
  minDate: any;
  maxDate: any;
  isLoading: boolean=false;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false
  };
  closeResult: string;
  private modalRef: NgbModalRef;

  constructor(private userMgmtService: UserMgmtService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.getUserList();
  }

  queryParams() {
    let query = "";
    if (this.searchUserStatus && this.searchUserStatus != "all") query = query + "status=" + this.searchUserStatus+"&";
    
    if (this.searchBy && this.searchBy == "mobile" && this.searchText && this.searchText !== "") {
      query = query + "mobile=" + this.searchText.trim()+"&";
    }
    if (this.searchBy && this.searchBy == "email" && this.searchText && this.searchText !== "") {
      query = query + "email=" + this.searchText.trim()+"&";
    }
    if (this.searchStartDate && this.searchStartDate != "") {
      // convert to epoch time
      let startDate = new Date(this.searchStartDate);
      query = query + "startDate=" + Math.floor(startDate.getTime() / 1000);
    }
    if (this.searchEndDate && this.searchEndDate != "") {
      // convert to epoch time
      let endDate = new Date(this.searchEndDate);
      endDate.setDate(endDate.getDate() + 1);
      query = query + "&endDate=" + Math.floor(endDate.getTime() / 1000);
    }
    return query;
  }
  // GET USERS (By Default ALL)
  getUserList() {
    let queryParam = "";
    var queryValue = this.queryParams();
    this.isLoading = true;
    this.userMgmtService.getUserListApi(queryValue).subscribe(
      res => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          this.userList = res["data"]["userList"];
          console.log(this.userList)
        } else {
          this.userList = [];
        }
        this.isLoading = false;
      },
      err => {
        this.isLoading = false;
      }
    );
  }

  onReset() {
    this.isLoading = true;
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.isLoading= false;
    }, 2000);
    this.searchUserStatus = "",
    this.searchText = "",
    this.searchBy ="",
      (this.searchStartDate = ""),
      (this.searchEndDate = "");
    this.getUserList();
  }

  searchFiltersBtn() {
    this.getUserList();
  }

  prepareUpdateStatusForm() {
    this.statusForm = this.formBuilder.group({
      newStatus: ["", [Validators.required]]
    });
  }

  updateUserStatusModal(row, content, btn) {
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size:"md"
    };
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.userDetails = row;
    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  openModal(row, content, btn) {
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size:"xl"
    };
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.userRewardWeekly(row.userId);
    this.userRewardPermanent(row.userId);
    this.details = row;
    console.log(this.details)
    this.modalRef = this.modalService.open(content, this.modelOptions);
    
    this.modalRef.result.then(
      
      result => {
        this.closeResult = `Closed with: ${result}`;
        this.weeeklyRewardList = []
        this.permanentRewardList = []
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.weeeklyRewardList = []
        this.permanentRewardList = []
      }
    );
  }

  userRewardWeekly(queryParam) {
    let query = "userId="+queryParam
    this.isLoading = true;
    this.userMgmtService.getUserRewardWeeklyApi(query).subscribe(
      res => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          this.weeeklyRewardList = res["data"]["rewardList"];
          console.log(this.weeeklyRewardList,"WEEKLu")
        } else {
          this.weeeklyRewardList = [];
        }
        this.isLoading = false;
      },
      err => {
        this.isLoading = false;
      }
    );
  }

  userRewardPermanent(queryParam) {
    let query = "userId="+queryParam
    this.isLoading = true;
    this.userMgmtService.getUserRewardPermanentApi(query).subscribe(
      res => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          this.permanentRewardList = res["data"]["rewardList"];
          console.log(this.permanentRewardList,"PERMA")
        } else {
          this.userList = [];
        }
        this.isLoading = false;
      },
      err => {
        this.isLoading = false;
      }
    );
  }



  updateUserStatus(test) {
    this.statusFormSubmitted = true;
    if (this.statusForm.valid) {
      this.isLoading = true;
      let finalObj = {
        userId: this.userDetails["userId"],
        status: this.statusForm.controls.newStatus.value
      };
      this.userMgmtService.updateUserStatus(finalObj).subscribe(
        data => {
          this.isLoading = false;
          if ((data["message"] = "Success")) {
            Swal.fire("Success", "User status updated successfully!", "success");
            this.modalRef.close();
            this.getUserList();
          } else {
            Swal.fire("Error", data.data, "error");
          }
        },
        err => {
          this.isLoading = false;
          Swal.fire("Error", err.error.data, "error");
          this.modalRef.close();
          this.getUserList();
        }
      );
    }
  }
  showImage(image:any) {
    if (image) {
      Swal.fire({
        imageUrl: image,
        imageHeight: 250,
        imageWidth: 250
      });
    }
   }

  // END ----- Update user status block
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

}
